export default __webpack_public_path__ + "static/media/4t.a0125a02.jpg";